import React,{useState} from 'react'
import TablesTab from './tablesTab'

function Tabfrm({data,actions,setModal}){
    const [hall, setHall] = useState(data.hall) 

 
    return(
        <div className='modal'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'></div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' style={{width:'350px',height:'350px'}}>
            <TablesTab userId={data.user_id} hall={hall} setHall={setHall} tblClick={actions.tblClick} Data={data.catHalls} Orders={data.orders} Rights={data.rights}/>
            </div>
        </div></div>
    )
}

export default Tabfrm